export enum RelationshipTypes {
	None,
	Parent,
	ToItself,
	Child
}